export default __webpack_public_path__ + "static/media/bg-poli.aa88847c.svg";